import { SubsidyConfiguration } from "./../../../../models/domains/pbm/Benefit/subsidy-configuration";
import { AbstractParser } from "../../parser";
import { SubsidyConfigurationCluster } from "src/app/ui/models/domains/pbm/Benefit/subsidy-configuration-cluster";
import { ProductType } from "src/app/ui/models/domains/pbm/Benefit/product-type";

export class SubsidyConfigurationParser extends AbstractParser<SubsidyConfigurationCluster> {
  parse(payload: any): SubsidyConfigurationCluster {
    const subsidyConfiguration = new SubsidyConfigurationCluster();
    subsidyConfiguration.setKey(payload.Key);
    subsidyConfiguration.setCompanyFiscalNumber(payload.CompanyFiscalNumber);
    subsidyConfiguration.setSubsidyMappingConfiguration(this.subsidyMappingConfigurationParser(payload.SubsidyMappingConfiguration));
    return subsidyConfiguration;
  }

  private subsidyMappingConfigurationParser(payload: any): Array<SubsidyConfiguration> {
    const subsidyConfigurationList: Array<SubsidyConfiguration> = [];
    payload.forEach((configuration) => {
      const subsidyConfiguration = new SubsidyConfiguration();
      subsidyConfiguration.setProductType(this.addProductType(configuration.ProductType));
      subsidyConfiguration.setRemainingPurchasePaymentMethod(configuration.RemainingPurchasePaymentMethod);
      subsidyConfiguration.setSubsidyLimit(configuration.SubsidyLimit);
      subsidyConfiguration.setAllowSubsidyLimitExceed(configuration.AllowSubsidyLimitExceed);
      subsidyConfiguration.setAllowPurchaseUseReceipt(configuration.AllowPurchaseUseReceipt);
      subsidyConfigurationList.push(subsidyConfiguration);
    });
    return subsidyConfigurationList;
  }

  private addProductType(key: string): ProductType {
    const productType = new ProductType();
    productType.setKey(key);
    productType.setValue(null);
    return productType;
  }
}
